module.exports = __webpack_public_path__ + "img/yizhengtc2.1375b069.jpg";